import React from 'react';
import { string } from 'prop-types';

const INCOME = ({ title, color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
    <title>{title}</title>
    <g id="icons">
      <path
        d="M35.89,20H14.11A6.75,6.75,0,0,1,10,24.2v4.61A6.75,6.75,0,0,1,14.11,33H35.89A6.75,6.75,0,0,1,40,28.8V24.2A6.75,6.75,0,0,1,35.89,20ZM25,30a4,4,0,1,1,4-4A4,4,0,0,1,25,30Z"
        fill={color}
      />
      <path
        d="M4.88,15V38H45.12V15ZM42,30.36A4.78,4.78,0,0,0,37.47,35H12.53A4.78,4.78,0,0,0,8,30.36V22.64A4.78,4.78,0,0,0,12.53,18H37.47A4.78,4.78,0,0,0,42,22.64Z"
        fill={color}
      />
    </g>
  </svg>
);

INCOME.defaultProps = {
  title: '',
  color: '#ccc',
};

INCOME.propTypes = {
  title: string,
  color: string,
};

export default INCOME;
